import React from 'react';
import { hashCode } from './String';
import useMap from './useMap';
import { Palette } from './Palette';
const createRadar = (radar, map) => new google.maps.Circle({
    center: radar.location,
    strokeColor: Palette.Radar,
    strokeOpacity: 0.85,
    strokeWeight: 4,
    fillColor: Palette.Radar,
    fillOpacity: 0.12,
    radius: radar.radius,
    map,
});
function useRadar(radar) {
    const { map } = useMap();
    const ref = React.useRef(new Map());
    React.useEffect(() => {
        if (!map) {
            return;
        }
        if (!radar) {
            ref.current.forEach((c) => c.setMap(null));
            ref.current.clear();
            return;
        }
        const oldKeys = new Set([...ref.current.keys()]);
        const newKey = hashCode(JSON.stringify(radar));
        [...oldKeys]
            .filter((e) => newKey !== e && ref.current.has(e))
            .forEach((e) => {
            ref.current.get(e)?.setMap(null);
            ref.current.delete(e);
        });
        if (!ref.current.has(newKey)) {
            ref.current.set(newKey, createRadar(radar, map));
        }
    }, [radar, map]);
    return {};
}
export default useRadar;
